import { DialogActions, FormControl } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsExtensionToProps } from "../../redux/api-connect/extension";
import { mapActionsGroupToProps } from "../../redux/api-connect/group";
import { mapActionsIvrToProps } from "../../redux/api-connect/ivr";
import { mapActionsToProps } from "../../redux/api-connect/phoneNumber";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      targetType: "",
      targetId: "",
      checkCallUrl: "",
      length: 0,
      data: [],
      modalSend: false,
      item: {},
      modalAction: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
    };
  }
  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "phone", numeric: false, disablePadding: false, label: "Đầu số" },
    { id: "state", numeric: false, disablePadding: false, label: "Trạng thái" },
    {
      id: "targetType",
      numeric: false,
      disablePadding: false,
      label: "Đích đến",
    },
    // { id: 'targetName', numeric: false, disablePadding: false, label: 'Tên đích đến' },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Ngày tạo",
    },
    {
      id: "actionEdit",
      numeric: false,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    this.props.getPhoneNumberAction();
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmit = () => {
    const { id, targetType, targetId, checkCallUrl } = this.state.item;
    this.props.changePhoneNumberAction(targetType, targetId, id, checkCallUrl);
    this.setState({ modalAction: false });
  };

  handleOpenModalEdit = (item) => {
    this.props.getIvrsAction();
    this.props.getExtensionAction();
    this.setState({ item: item, modalAction: !this.state.modalAction });
  };

  handleClose = () => {
    this.setState({ modalAction: false });
  };

  handleChange = (name) => {
    return (event) => {
      const value = event.target.value;
      this.setState({
        item: {
          ...this.state.item,
          [name]: value,
        },
      });
    };
  };

  renderMenuItem = () => {
    const { targetType } = this.state.item;
    const {
      ivrs: { items },
      extension,
      group,
    } = this.props;
    return targetType == "ivr"
      ? items
        ? items.map((item) => {
            return (
              <MenuItem key={item.id} value={item.id}>
                {item.aliasName}
              </MenuItem>
            );
          })
        : null
      : targetType == "extension"
      ? extension.items
        ? extension.items.map((ex) => {
            return (
              <MenuItem key={ex.id} value={ex.id}>
                {ex.userId}
              </MenuItem>
            );
          })
        : null
      : group.items
      ? group.items.map((gr) => {
          return (
            <MenuItem key={gr.id} value={gr.id}>
              {gr.aliasName}
            </MenuItem>
          );
        })
      : null;
  };

  render() {
    const { classes, listPhoneNumbers } = this.props;
    const { filters } = this.state;
    const listPhoneNumberResult =
      typeof listPhoneNumbers === "object"
        ? Object.keys(listPhoneNumbers).map((key) => listPhoneNumbers[key])
        : listPhoneNumbers;
    const { targetType, targetId, checkCallUrl } = this.state.item;
    return (
      <React.Fragment>
        <TableData
          {...this.props}
          nameTable="Danh sách đầu số"
          items={listPhoneNumberResult}
          rowsPerPage={filters.pageSize}
          count={listPhoneNumberResult ? listPhoneNumberResult.length : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleEdit={this.handleOpenModalEdit}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        <Dialog
          open={this.state.modalAction}
          title="Update webhook"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleSubmit}
              onError={(errors) => console.log(errors)}>
              <FormControl className={classes.form}>
                <SelectValidator
                  variant="outlined"
                  className={classes.input}
                  placeholder="Đích đến"
                  select
                  label="Đích đến"
                  onChange={this.handleChange("targetType")}
                  name="targetType"
                  value={targetType}
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}>
                  <MenuItem key="ivr" value="ivr">
                    IVR
                  </MenuItem>
                  <MenuItem key="group" value="group">
                    Hàng đợi
                  </MenuItem>
                  <MenuItem key="extension" value="extension">
                    Máy lẻ
                  </MenuItem>
                </SelectValidator>
                <SelectValidator
                  variant="outlined"
                  className={classes.input}
                  placeholder="Tên đích đến"
                  label="Tên đích đến"
                  onChange={this.handleChange("targetId")}
                  name="targetId"
                  value={targetId}
                  InputProps={{
                    readOnly: targetType ? false : true,
                  }}
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}>
                  {this.renderMenuItem()}
                </SelectValidator>
                <TextValidator
                  placeholder="Url sự kiện cuộc gọi"
                  label="Url sự kiện cuộc gọi"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("checkCallUrl")}
                  name="checkCallUrl"
                  value={checkCallUrl}
                />
              </FormControl>
              <DialogActions>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  size="small">
                  Lưu
                </Button>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  variant="contained"
                  size="small">
                  Hủy
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

PhoneNumber.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listPhoneNumbers: state.apiConnectPhoneNumber.phoneNumbers,
  ivrs: state.apiConnectIvr.ivrs,
  extension: state.apiConnectExtension.extensions,
  group: state.apiConnectGroup.groups,
});

const GroupConnect = connect(
  mapStateToProps,
  mapActionsGroupToProps
)(PhoneNumber);

const ExtensionConnect = connect(
  null,
  mapActionsExtensionToProps
)(GroupConnect);

const IvrConnect = connect(null, mapActionsIvrToProps)(ExtensionConnect);

PhoneNumber = connect(null, mapActionsToProps)(IvrConnect);

export default withStyles(styles)(PhoneNumber);
